export const SET_SESSION_DATA = 'SET_SESSION_DATA';

export function setSessionData(sessionData) {
  return {
    type: SET_SESSION_DATA,
    payload: sessionData
  };
}

export function getSessionData(state) {
  return state.session;
}

const initialState = {
  id: '',
  token: ''
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_SESSION_DATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
